import { GeckoAssetModel } from 'types/entries/geckoAssetModel'
import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'

import { GeckoAssetModelType } from './assetModelEnums'
import { GeckoHoodAssetModel } from './geckoHoodAssetModel'
import { GeckoLegacyBoilerAssetModel } from './geckoLegacyBoilerAssetModel'
import { GeckoMachinedForgingAssetModel } from './geckoMachinedForgingAssetModel'
import { GeckoPipelineAssetModel } from './geckoPipelineAssetModel'
import { GeckoPressureVesselAssetModel } from './geckoPressureVesselAssetModel'
import { GeckoShipAssetModel } from './geckoShipAssetModel'
import { GeckoVerticalTankAssetModel } from './geckoVerticalTankAssetModel'

/**
 *
 * @param json Rolodex Json (already determined to be some kind of asset model json)
 * @returns the specific asset model created via the json passed in. Vertical tank, piping etc...
 * TODO: when we add more types of asset model expand this out to a switch
 */
export function createGeckoAssetModel(json: RolodexEntryJson) {
  if (json.data.type === GeckoAssetModelType.VerticalTank) {
    return GeckoVerticalTankAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.LegacyBoiler) {
    return GeckoLegacyBoilerAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.Piping) {
    return GeckoPipelineAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.MachinedForging) {
    return GeckoMachinedForgingAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.Ship) {
    return GeckoShipAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.PressureVessel) {
    return GeckoPressureVesselAssetModel.CreateFromJSON(json)
  } else if (json.data.type === GeckoAssetModelType.Hood) {
    return GeckoHoodAssetModel.CreateFromJSON(json)
  } else {
    return GeckoAssetModel.CreateFromJSON(json)
  }
}
